import React, { useEffect, useRef, createElement, Fragment, useCallback, useMemo } from 'react';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { autocomplete } from '@algolia/autocomplete-js';
import styled from '@emotion/styled';
import { Box } from 'theme-ui';
import { render } from 'react-dom';
import '@algolia/autocomplete-theme-classic';

const AutocompleteSearchBox = ({searchClient, indexName, submitHandler = null, setQueryLabel = null}) => {
  const containerRef = useRef(null);
  const { setIndexUiState } = useInstantSearch();
  const { query } = useSearchBox();

  useEffect(() => {
    if(setQueryLabel && query) {
      setQueryLabel(query);
    }
  }, [query])

  const plugins = useMemo(() => {
    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
      indexName,
      searchClient,
      transformSource({ source }) {
        return {
          ...source,
          onSelect({ item }) {
            if(submitHandler) {
              submitHandler(item.query)
            } else {
              setIndexUiState((indexUiState) => ({
                ...indexUiState,
                query: item.query,
            }));
          }
          },
        };
      },
    });

    return [querySuggestionsPlugin];
  }, []);

  const initialState = useMemo(() => ({ query }), [query]);

  const onReset = useCallback(
    () =>
      setIndexUiState((indexUiState) => ({
        ...indexUiState,
        query: '',
      })),
    []
  );

  const onSubmit = useCallback(
    ({state}) =>
     { 
      if(submitHandler) {
        submitHandler(state.query)
      } else {
        setIndexUiState((indexUiState) => ({
          ...indexUiState,
          query: state.query,
        }))
      }
      },
    []
  );

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const search = autocomplete({
      plugins,
      onReset,
      initialState,
      insights: true,
      placeholder: "Search",
      onSubmit,
      container: containerRef.current,
      renderer: { createElement, Fragment, render },
    });

    return () => search.destroy();
  }, [plugins]);

  return <StyledSearchboxContainer ref={containerRef} />;
}

const StyledSearchboxContainer = styled(Box)`
  width: 100%;
  form {
    display: flex;
    border: 1px solid #d2d1d2;
    border-radius: 0.5rem;
  }
  .aa-Form:focus-within {
    box-shadow: none;
    outline: none;
    border: 2px solid #aa00ea;
  }
  .aa-InputWrapperPrefix {
    order: 3;
    label {
      margin: 0;
    }
    button {
      padding: 10px 14px;
      svg {
        fill: #777679;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .aa-InputWrapper {
    order: 1;
    input {
      padding: 10px 14px;
    }
  }
  .aa-InputWrapperSuffix {
    order: 2;
    button:focus {
      outline: none;
    }
  }
`;

export default AutocompleteSearchBox;
